module.exports = __webpack_public_path__ + "static/media/columbia_getty_desktop.23536740.jpg";